import moment from "moment";
import { axios } from "../../../../lib/axios";

// --------------- response--------------------------------

const newPayload = ({ requestType, patientId, encounterId, text, document, status = "draft", documentName  }) => {
    const currentDateTime = moment().format("YYYY-MM-DDTHH:mm:ss[Z]")
    return {
        resourceType: "ServiceRequest",
        requestType, //lab,referral,diagnostic
        status,
        intent: "order",
        priority: "routine",
        patientId,
        encounterId,
        locationReferenceId: "",
        time: currentDateTime,
        text,
        occurrenceDateTime: currentDateTime,
        documentName: documentName
    }
}

export const createServiceRequest = (payload) => {
    const body = newPayload(payload);
    const patientId = encodeURIComponent(payload.patientId);
    return axios.post(`/servicerequest?patientId=${patientId}`, body);
};

export const editServiceRequest = ({ id, ...payload }) => {
    return axios.put(`/servicerequest/${id}`, { ...payload });
};

export const deleteServiceRequest = (serviceId) => {
    return axios.put(`/servicerequest/${serviceId}`, {
        active: false
    });
};

export const sendSFT = (payload) => {
    return axios.post(`/securefiletransfer`, payload);
};

export { buildInternalReferralPayload, buildWaitingRoomPayload } from "../../ServiceRequest/internalReferralPayload";

export const createInternalReferral = (payload) => {
    const patientId = payload?.patient?.id || payload?.patient?.reference?.replace(/^Patient\//, "");
    if (!patientId) return Promise.reject(new Error("A patient is required for an internal referral."));
    return axios.post(`/servicerequest/refer?patientId=${encodeURIComponent(patientId)}`, {
        ...payload, patient: { ...payload.patient, id: patientId },
    }).then(response => {
        if (response?.status !== true) throw new Error(response?.message || "Could not save the referral.");
        return response;
    });
};
